import React from "react";
import { t } from "../../../utils/i18n";

const Head = () => (
  <thead>
    <tr>
      <th></th>
      <th><i class="fas fa-info-circle" title={t("stores.activity.date_title")}></i> {t("stores.activity.date")}</th>
      <th><i class="fas fa-info-circle" title={t("stores.activity.amount_title")}></i> {t("stores.activity.amount")}</th>
      <th><i class="fas fa-info-circle" title={t("stores.activity.type_title")}></i> {t("stores.activity.type")}</th>
      <th><i class="fas fa-info-circle" title={t("stores.activity.description_title")}></i> {t("stores.activity.description")}</th>
      <th><i class="fas fa-info-circle" title={t("stores.activity.status_title")}></i> {t("stores.activity.status")}</th>
      <th></th>
      <th></th>
      <th></th>
    </tr>
  </thead>
);

export default Head;
